import { render, staticRenderFns } from "./CreditDetail.vue?vue&type=template&id=36ea29ba"
import script from "./CreditDetail.vue?vue&type=script&lang=js"
export * from "./CreditDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports